[
  {
    "taxKey": "TaxAdditionalMedicare",
    "filingStatus": "Single Taxpayers",
    "taxRate": 0.009,
    "threshold": 200000
  },
  {
    "taxKey": "TaxAdditionalMedicare",
    "filingStatus": "Married Filing Jointly",
    "taxRate": 0.009,
    "threshold": 250000
  },
  {
    "taxKey": "TaxAdditionalMedicare",
    "filingStatus": "Married Filing Separately",
    "taxRate": 0.009,
    "threshold": 125000
  },
  {
    "taxKey": "TaxAdditionalMedicare",
    "filingStatus": "Head of Household",
    "taxRate": 0.009,
    "threshold": 200000
  },
  {
    "taxKey": "TaxNetInvestmentIncome",
    "filingStatus": "Single Taxpayers",
    "taxRate": 0.038,
    "threshold": 200000
  },
  {
    "taxKey": "TaxNetInvestmentIncome",
    "filingStatus": "Married Filing Jointly",
    "taxRate": 0.038,
    "threshold": 250000
  },
  {
    "taxKey": "TaxNetInvestmentIncome",
    "filingStatus": "Married Filing Separately",
    "taxRate": 0.038,
    "threshold": 125000
  },
  {
    "taxKey": "TaxNetInvestmentIncome",
    "filingStatus": "Head of Household",
    "taxRate": 0.038,
    "threshold": 200000
  }
]
